var render = function (_h,_vm) {var _c=_vm._c;return _c('div',[_c('div',{class:Object.entries(_vm.props).map(function (ref) {
	var k = ref[0];
	var v = ref[1];

	return (v !== undefined ? k : null);
})},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }